var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTubeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_tube)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3109 9.99929C18.3109 13.5624 15.4926 16.4518 12.0182 16.4518C8.54298 16.4518 5.72697 13.5624 5.72697 9.99929C5.72697 6.43675 8.54303 3.54821 12.0182 3.54821C15.4926 3.54816 18.3109 6.43675 18.3109 9.99929ZM12.0182 0C6.63225 0 2.2666 4.47716 2.2666 9.99929C2.2666 15.5225 6.63225 20 12.0182 20C17.4031 20 21.7685 15.5225 21.7685 9.99929C21.7685 4.47716 17.4031 0 12.0182 0Z",
    fill: "#E1251B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 7.98047H0V12.0255H24V7.98047Z",
    fill: "#000F9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_tube"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeIcon);
export default __webpack_public_path__ + "static/media/tube-icon.cb12a15d1ae6ad66cb53496c6cb4ce9a.svg";
export { ForwardRef as ReactComponent };